<div class="linked-job-badges" *ngIf="showNotify" (click)="openSummary(); $event.stopPropagation()">
  <div class="badge-row" *ngIf="showPatientJobs">
    <mat-icon>people</mat-icon>
    <span class="job-pill">{{ patientPosition() }}</span>
    <span class="job-pill" *ngIf="summary?.patientReadyCount">{{ patientReady() }}</span>
  </div>
  <div class="badge-row" *ngIf="showGroupJobs">
    <mat-icon>{{ groupIconName() }}</mat-icon>
    <span class="job-pill">{{ groupPosition() }}</span>
    <span class="job-pill" *ngIf="summary?.groupReadyCount">{{ groupReady() }}</span>
  </div>
  <span class="notify-pill">{{ notifyLabel() }}</span>
</div>
